import BaseService from './BaseService'
import { ILocation, IUnsetFields } from '../models/api/Location'

class LocationsService extends BaseService {
    constructor(baseUrl: string) {
      super(baseUrl)
    }

    ids = (ids) => this.requests.post(`/ids`, { ids })
    getTags = (locationId: string) =>
        this.requests.get(`/${locationId}/tags`)
    search = (companyId, deleted, status?, skip?, limit?, query?) =>
        this.requests.get(`/search?deleted=${deleted}&companyId=${companyId}${status ? `&status=${status}` : ''}${skip ? `&skip=${skip}` : ''}${limit ? `&limit=${limit}` : ''}${query ? `&query=${encodeURIComponent(query)}` : ''}`)
    searchQuery = (companyId, deleted, query) =>
        this.requests.get(`/search?deleted=${deleted}&companyId=${companyId}&query=${query ? encodeURIComponent(query) : query}&limit=50`)
    keys = (companyId, deleted, status?, skip?, limit?, query?) =>
        this.requests.get(`/keys?deleted=${deleted}&companyId=${companyId}${skip ? `&skip=${skip}` : ''}${limit ? `&limit=${limit}` : ''}`)
    keysQuery = (companyId, deleted, query) =>
        this.requests.get(`/keys?deleted=${deleted}&companyId=${companyId}&query=${query}&limit=50`)
    create = (body: ILocation) => this.requests.post('/', body)
    update = (locationId: string, body: ILocation) => this.requests.put(`/${locationId}`, body)
    updateES = (locationId: string, companyId: string) => this.requests.put(`/elasticsearch/${locationId}/userActivity?companyId=${companyId}`)
    unsetFields = (locationId: string, body: IUnsetFields) => this.requests.put(`/${locationId}/unset-fields`, body)
    delete = (locationId: string) => this.requests.delete(`/${locationId}`)
    getById = (locationId: string) =>  this.requests.get(`/${locationId}`)
    Tag = {
        search: (locationId: string, query: { [key: string]: any }) => this.requests.get(`/${locationId}/tags/search${query ? '?' + new URLSearchParams(query).toString() : ''}`),
    }
    getLabsFeatures = (type: 'location' | 'company' = 'location') => this.requests.get(`/labs/features?type=${type}`)
    getMetaContent = (locationId: string) => this.requests.get(`/${locationId}/meta-content`)
}

const instance = new LocationsService(BaseService.servicesConfig.Locations as string)

export default instance
